<template>
  <listview :vm="listVm" />
</template>

<script>
  import Listview from '@/components/base/Listview';
  import ListVm from '@/components/base/ListVm';
  import Router from '@/router';
  import Format from '@/format';

  const _comp = {
    name: 'Facturen',
    data: () => ({
      listVm: null
    }),
    created() {
      this.listVm = new ListVm(
        'Facturen',
        'Posting_Date desc',
        (ctx) => `/odata/PostedSalesInvoice?$filter=Posting_Date ge ${ctx.year}-01-01T00:00:00Z and Posting_Date le ${ctx.year}-12-31T23:59:59Z`,
        ['Due_Date', 'Posting_Date'],
        (srch, items) => items.filter(i => `${i.No}${i.Order_No}${i.Your_Reference}${i.External_Document_No}`.toLowerCase().indexOf(srch.toLowerCase()) != -1),
        (item) => Router.push('/Factuur/' + item.No),
        [
          { name: 'Nr.', sort: 'No', select: i => i.No },
          { name: 'Orderklantnr.', sort: 'Bill_to_Customer_No', select: i => i.Bill_to_Customer_No },
          { name: 'Naam', sort: 'Bill_to_Name', select: i => i.Bill_to_Name },
          { name: 'Boekingsdatum', sort: 'Posting_Date', select: i => Format.date(i.Posting_Date) },
////////////////////////////////
          { name: 'Vervaldatum', sort: 'Due_Date', select: i => Format.date(i.Due_Date) },
////////////////////
          { name: 'Ordernummer', sort: 'Order_No', select: i => i.Order_No },
          { name: 'Bedrag ex. BTW', sort: 'Amount', select: i => Format.eur(i.Amount) },
          { name: 'Bedrag incl. BTW', sort: 'Amount_Including_VAT', select: i => Format.eur(i.Amount_Including_VAT) },
/////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////
////////////////////
          { name: 'Extern documentnr', sort: 'External_Document_No', select: i => i.External_Document_No },
        ]
      );
    },
    components: {
      'listview': Listview
    }
  };

  export default _comp;
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Facturen.vue